import { useTranslation } from "react-i18next";
import Footer from "../components/Footer";
import Header from "../components/Header";
import Title from "../components/Title";
import { CONTACT_PATH } from "../Routes/paths";
import { useNavigate } from "react-router-dom";
import Contact from "../components/Contact";

interface CarRentalSystemProps {}

const CarRentalSystem = ({}: CarRentalSystemProps) => {
  const { i18n, t } = useTranslation();
  const navigate = useNavigate();
  return (
    <>
      <Header />

      <main
        className={`w-full ${
          i18n.language === "en" ? "font-Poppins" : "font-Almarai"
        }`}
      >
        {/* hero section  *****************************/}
        <Title
          title={t("Car Rental System")}
          subtitle={t("Services")}
          thirdTitle={t("Car Rental System")}
        />

        {/* next section  ******************************/}
        <section className="my-[20px] px-[20px] w-full flex flex-col items-center justify-center gap-8 lg:gap-0 lg:flex-row lg:items-center lg:justify-around ">
          <div>
            <img src="../images/carrental.png" alt="" />
          </div>
          <div>
            <p
              className={`max-w-[800px] lg:text-[14px] text-center ${
                i18n.language === "en" ? "lg:text-left" : "lg:text-right"
              }`}
            >
              {t(
                "Our Car Rental System is designed to streamline your car rental business, providing a seamless experience for both you and your customers. With our state-of-the-art software, you can manage your fleet, reservations, and customer interactions with ease. Our platform integrates advanced technologies to automate routine tasks, reducing administrative burdens and allowing you to focus on delivering exceptional customer service. The intuitive dashboard offers a comprehensive view of your operations, giving you real-time access to critical information such as vehicle availability, rental schedules, and customer preferences."
              )}
            </p>
          </div>
        </section>

        {/*  Our core service is developing **************/}
        <section className="my-[100px] px-[20px] lg:px-[144px] 2xl:px-[180px] w-full flex flex-col gap-10">
          <p className="font-[700] text-[24px] lg:text-[28px] flex items-center justify-center">
            {t("The Features of Our Car Rental System")}
          </p>

          {/* grid section  *****************/}
          <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div>
              <p className="w-full font-[700] text-[20px]">
                {t("Smoother Design")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "We choose the design through our feelings and experience, we need to give our client the feel of peace, warm and the freedom."
                )}
              </p>
            </div>

            <div>
              <p className="w-full font-[700] text-[20px]">
                {t("Intelligent Profiles")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "The new version of Onyxcom car rental system brings the most intelligent profiles system that it recognizes all of your cars, customers and orders."
                )}
              </p>
            </div>

            <div>
              <p className="w-full font-[700] text-[20px]">
                {t("Easy Integrations")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "Unified platform for all office personnel, integrating Traffic fines, SALIK Credit automation, and SMS notifications. With our API system."
                )}
              </p>
            </div>

            <div>
              <p className="w-full font-[700] text-[20px]">
                {t("Multilingual")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "Our system work with Multilingual and its already (Arabic (fully RTL) – English) and you can create your own language file."
                )}
              </p>
            </div>

            <div>
              <p className="w-full font-[700] text-[20px]">
                {t("Access form Any Where")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "The system can be accessed from any where from any device, its responsive, all you need is a web browser and internet connection."
                )}
              </p>
            </div>

            <div>
              <p className="w-full font-[700] text-[20px]">
                {t("Huge Permissions")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "Now you can Create, Edit and Manage Unlimited Users and assigning Unlimited Roles and Permissions to their Unlimited Groups."
                )}
              </p>
            </div>

            <div>
              <p className="w-full font-[700] text-[20px]">
                {t("Third Party Access")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "Now you can give a username and password to any one you want to access a specific data in your system with the permissions and IDs."
                )}
              </p>
            </div>

            <div>
              <p className="w-full font-[700] text-[20px]">
                {t("Printing Factory")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "Imagine ad Design all your prints by your-self, no locks any more you can design your prints template as much as you want."
                )}
              </p>
            </div>

            <div>
              <p className="w-full font-[700] text-[20px]">
                {t("ID Card Reader")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "Adding customers within a second by our U.A.E ID Card Reader. rather than typing your data."
                )}
              </p>
            </div>

            <div>
              <p className="w-full font-[700] text-[20px]">
                {t("Traffic Fines")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "Auto Traffic Fines Importing and TF discount updating with live updates for all types of traffic fines with direct access to uae traffic fines police system."
                )}
              </p>
            </div>

            <div>
              <p className="w-full font-[700] text-[20px]">{t("Salik")}</p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "Auto Salik Portal and Balance Importer, allowing you to seamlessly manage and monitor toll charges for your fleet."
                )}
              </p>
            </div>

            <div>
              <p className="w-full font-[700] text-[20px]">
                {t("Bar Code System")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "Activate bar code generator and speed your search process and leave away searching headache."
                )}
              </p>
            </div>

            <div>
              <p className="w-full font-[700] text-[20px]">
                {t("QR Code Generator")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "What about letting your customer tracking their orders from their smart phones, its great, right?"
                )}
              </p>
            </div>

            <div>
              <p className="w-full font-[700] text-[20px]">
                {t("Multi-Columns Filtering")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "You have a lot of data, you can find what you are looking for with a little information."
                )}
              </p>
            </div>

            <div>
              <p className="w-full font-[700] text-[20px]">
                {t("Update on the GO")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "With this totally new web application you can upload a file, image, photo directly from your mobile camera from any where to your system."
                )}
              </p>
            </div>

            <div>
              <p className="w-full font-[700] text-[20px]">
                {t("Fully Dynamic CP")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "Your employee make a mistake on any field in the system, you want to edit it easily?, take a look at System Settings section."
                )}
              </p>
            </div>

            <div>
              <p className="w-full font-[700] text-[20px]">
                {t("Huge Features")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "More than +70 features already added to the new version of node cars rental system."
                )}
              </p>
            </div>

            <div>
              <p className="w-full font-[700] text-[20px]">
                {t("Advanced Reports")}
              </p>
              <p className="text-[14px] max-w-[536px]">
                {t(
                  "How can the node car rental system make my working hours more easy?, OK, that’s already achieved through the “all in all” connection."
                )}
              </p>
            </div>
          </div>
        </section>

        {/* Connect With Us: Your Voice Heard **************/}
        <Contact />
      </main>

      <Footer />
    </>
  );
};

export default CarRentalSystem;
